import { render, staticRenderFns } from "./PublicClientProtocolInfo.vue?vue&type=template&id=31df1952&scoped=true&"
import script from "./PublicClientProtocolInfo.vue?vue&type=script&lang=js&"
export * from "./PublicClientProtocolInfo.vue?vue&type=script&lang=js&"
import style0 from "./PublicClientProtocolInfo.vue?vue&type=style&index=0&id=31df1952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31df1952",
  null
  
)

export default component.exports